import styled from 'styled-components/macro';
import { themeGet } from '@styled-system/theme-get';

export const StyledSlider = styled.div`
  margin-bottom: 36px;
`;

export const StyledContent = styled.div`
  overflow: hidden;
  position: relative;
  border-radius: ${themeGet('radii.base')};
`;

export const StyledRail = styled.div`
  width: 100%;
  height: 25px;
  background-color: ${themeGet('colors.text.border')};
`;

type TrackProps = {
  width?: string;
};

export const StyledTrack = styled.div<TrackProps>`
  position: absolute;
  top: 0;
  left: 0;
  width: ${(props) => (props?.width ? `${props.width}%` : '0')};
  height: 100%;
  background-color: ${themeGet('colors.primary.regular')};
  border-radius: ${themeGet('radii.base')};
  transition: width 0.35s ease;
`;

export const StyledLabel = styled.span`
  display: flex;
  justify-content: flex-end;
  font-size: ${themeGet('fontSizes.xxs')}px;
  font-weight: ${themeGet('fontWeights.semiBold')};
  color: ${themeGet('colors.body.text')};
`;
